import { render, staticRenderFns } from "./ListagemPenalidadesBotoesAcoes.vue?vue&type=template&id=4d53d074&scoped=true"
import script from "./ListagemPenalidadesBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ListagemPenalidadesBotoesAcoes.vue?vue&type=script&lang=js"
import style0 from "./ListagemPenalidadesBotoesAcoes.vue?vue&type=style&index=0&id=4d53d074&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53d074",
  null
  
)

export default component.exports